export default __webpack_public_path__ + "static/media/logo.17fb3c29.png";